module.exports = __webpack_public_path__ + "static/media/static-2.9d791974.jpg";